import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getSeoData, applyHead } from '@/lib/seo';
import { resolveSchemas, injectSchemas } from '@/lib/schema';

/**
 * Centralized route-aware SEO/head manager.
 * On every route change it rewrites the managed head tags (title, description,
 * keywords, canonical, Open Graph, Twitter Card) and injects the matching
 * Schema.org JSON-LD. Renders nothing to the UI.
 */
export default function SeoManager() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname.replace(/\/+$/, '') || '/';
    const seo = getSeoData(path);

    // Runtime OG/Twitter/meta tags.
    applyHead(seo);

    // Schema.org JSON-LD (kept in a separate module).
    const schemas = resolveSchemas(path, seo);
    injectSchemas(schemas);

    // Clean up JSON-LD injected for the previous route.
    return () => injectSchemas([]);
  }, [location.pathname]);

  return null;
}